export const tenantNameFromURL = () => {
  const host = window.location.host;
  const hostParts = host.split(".");
  return host.length > 1 ? hostParts[0] : null;
};

export const appsLogos: Record<string, string> = {
  "ct-smb": "/ct-smb.svg",
};

export const getAppLogo = (appCode: string): string => {
  return appsLogos[appCode] ?? `/${appCode}.png`;
};

